import enLocale from 'element-ui/lib/locale/lang/en'
module.exports = {
  ...enLocale,
  mobile: 'Mobile phone number',
  slug: 'Login name',
  email: 'Mailbox',
  selectLanguage: 'Language',
  chinese: 'Chinese',
  english: 'English',
  logout: 'Logout',
  netError: 'Network error. Try again later.',
  cancel: 'Cancel',
  confirm: 'Apply',
  delete: 'Delete',
  save: 'Save',
  recovery: 'Restore',
  rename: 'Rename',
  userSpace: 'Personal space',
  entSpace: 'Enterprise space',
  allUser: 'All users',
  frozen: 'Frozen',
  upload: 'Upload',
  import: 'Import',
  tips: 'Reminder',
  prompt: 'Reminder',
  success: 'Success',
  return: 'Back',
  edit: 'Edit',
  close: 'Close',
  noSearch: 'No search results',
  loadmore: 'Upload more',
  retry: 'Try again',
  allDelete: 'Delete all',
  nextStep: 'Next',
  nodata: 'No related query results',
  back: 'Previous',
  gotIt: 'Got it',
  ad: 'AD',
  corpWX: 'WeChat Work',
  dingding: 'DingTalk',
  oauth2: 'Oauth2',
  doublecase: 'DoubleCase',
  weaverOA: 'weaverOA',
  weaver: 'weaver',
  LDAP: 'LDAP',
  ADFS: 'ADFS',
  kingdee: 'Kingdee',
  captcha_plugin_wechat: 'WeCom',
  approve_plugin_weaver: 'weaver',
  moduleType: 'Module Type',
  serviceType: 'Service Type',
  search: 'Search',
  discription: 'Discription',
  creater: 'Creater',
  createTime: 'Create Time',
  version: 'Version',
  status: 'Status',
  operation: 'Operation',
  read: 'Read',
  start: 'Start',
  stop: 'Stop',
  data: 'Json Data',
  create: 'Create',
  pending: 'Pending',
  readStatus: 'Read Status',
  runing: 'Runing',
  toDelete: 'Confirm Deletion?',
  more: 'More',
  batchStart: 'Batch Start',
  batchStop: 'Batch Stop',
  batchDelete: 'Batch Delete',
  login: 'Login',
  area: 'Search for countries/regions',
  common: 'common',
  areaNull: 'No related countries or regions found',
  phonePlaceholder: 'Enter mobile phone number',
  actionSuccess: 'Successfully',
  networkError: 'Network connection failed',
  verificationError: 'Incorrect verification code',
  frozenTip: 'Account has been frozen, please contact the administrator',
  passwordError: 'Your input password is not correct ',
  loginError: 'Login failed',
  edas: {
    customfilter_err: 'You can input a maximum of 256 characters',
    scheme: 'Connection Type',
    empty_data: 'no datas',
    autoLogin:
      'Arouse the client through the three-party system and automatically log in (support Windows, Mac, iPhone, Android)',
    bindingConfig: 'Third-party binding',
    deliveryDefaultLoginTip: 'Also applies when logging in through links',
    uploadLable: 'upload',
    unUploadLabl: 'unUpload',
    startLabl: 'start',
    unStartLabl: 'unStart',
    stopedLabl: 'stoped',
    unStopLabl: 'unStop',
    deleteLabl: 'delete',
    unDeleteLabl: 'unDelete',
    exportFilter: 'Export conditions',
    pleaseEnter: 'Please enter ',
    proxyService: 'proxy service',
    syntaxError: 'syntax error',
    iconFormatLimit: 'Only PNG format is supported',
    iconBulkLimit: 'Image must be less than 50KB',
    iconSizeLimit: 'Image must be 40*40PX or more',
    iconScaleLimit: 'Image must be 1:1',
    iconTip: 'Please upload an icon in PNG format, 40*40PX or more, 1:1, 50KB or less.',
    loginIcon: 'Login Icon',
    filterCondition: 'Set filter conditions',
    enterFilter:
      'After setting, the nodes under the Base DN will be filtered according to the filter conditions. Currently only the LDAP filter syntax format is supported, such as cn=D_group1',
    ad: 'AD',
    baseDN: 'Base DN',
    appId: 'appId',
    ProviderSecret: 'ProviderSecret',
    secret: 'secret',
    authentication: 'Enterprise Certification',
    LDAP: 'LDAP',
    ADFS: 'ADFS',
    status: 'Status',
    operation: 'Operation',
    next: 'Next',
    last: 'Previous',
    delete: 'Delete',
    tips: 'Reminder',
    none: 'None',
    submit: 'Submit',
    hours: 'hour(s)',
    mins: 'Minute',
    more: 'More',
    back: 'Back',
    detail: 'Details',
    object: 'Object',
    action: 'Action',
    team: 'Team',
    frozen: 'Freeze',
    netError: 'Network error. Try again later.',
    setFilter: 'Set sync filter',
    import: 'Import',
    modify: 'Modify',
    upload: 'Upload',
    edit: 'Edit',
    condition: 'items',
    loadMore: 'Load more',
    items: 'items',
    agentId: 'agentId',
    weaver: 'weaver',
    weaverOA: 'weaverOA',
    customize: 'customize',
    URL: 'URL',
    departmentID: 'Department ID',
    departmentName: 'Department name',
    parentDepartment: 'Parent department',
    agentTips: 'The current service type does not need to select a proxy name',
    syncMode: 'Sync mode',
    syncOrganization: 'Sync to organization',
    syncTeam: 'Sync to team',
    syncUserOnly: 'Synchronize users only',
    syncOrganizationToolTip:
      'Synchronize the organizations and personnel of the docking system to the cloud organization',
    syncTeamToolTip:
      'Synchronize the personnel of the docking system to the organization and the organizational structure of the docking system to the team',
    syncTeamToolTipNotEnterPrise:
      'Synchronize the organizational structure of the docking system to the team',
    syncUserOnlyToolTip:
      'Synchronize only the personnel connected to the system to the root node of the organization, not the organization',
    syncUserOnlyToolTipNotEnterPrise:
      'Synchronize only the personnel connected to the system to the root node of the team, not the organization',
    remarks: 'remarks',
    move: 'Moved',
    mostCustomNumber: '	Up to {0} fields',
    createAgentFirst: 'Please configure proxy service first',
    hasNoAgentNow: 'No agency service',
    notNeedAgent: 'No proxy name required for current service type',
    connectFieldName: 'Name',
    connectFieldContent: 'Content',
    enterConnectFieldName: 'Please enter a connection configuration item name',
    enterConnectFieldContent: 'Please enter the connection configuration item',
    organization: 'department',
    unSyncOrganization: 'Unsynchronized departments',
    urlTip: 'Please enter a URL with http:// or https://',
    title: 'Enterprise account authentication',
    subHeader:
      'Connecting the box to the enterprise domain through proxy service,you can import and synchronize enterprise users and department structures.',
    subHeader2: 'ps:Work WeChat authentication service does not require proxy services.',
    importServerConfig: 'Department import service configuration',
    sync: 'Department import service configuration',
    authServerConfig: 'Login authentication service configuration',
    auth: 'Login authentication service configuration',
    binding: 'Third-party binding service configuration',
    agentName: 'Proxy name',
    serviceName: 'Service name',
    serial: 'Serial number',
    ctime: 'Create time',
    addAgentServer: 'Add proxy service',
    addServerConfig: 'Add service configuration',
    editServerConfig: 'Edit service configuration',
    add_import_config: 'Add department import service configuration',
    add_auth_config: 'Add login authentication service configuration',
    add_binding_config: 'Add third-party binding service configuration',
    add_sso_config: 'Add single sign service configuration',
    add_scan_config: 'Add QR code login service configuration',
    edit_import_config: 'Edit department import service configuration',
    edit_auth_config: 'Edit login authentication service configuration',
    edit_binding_config: 'Edit third-party binding service configuration',
    edit_sso_config: 'Edit single sign service configuration',
    edit_scan_config: 'Edit QR code login service configuration',
    autoSyncTime: 'Sync time',
    lastSyncTime: 'Last sync time',
    newAgentSrver: 'New proxy service',
    unbound: 'Remove binding',
    unbind: 'Unbound',
    normal: 'Normal',
    disconnect: 'Disconnected',
    hasAddAgentServer: 'Proxy service has been added',
    unboundTips:
      'The proxy service will be unavailable after unbinding. Are you sure you want to continue unbinding?',
    confirmUnbound: 'Continue unbinding',
    deleteTips:
      'The service will be unbound and relevant parameters will be cleared if it is deleted. Are you sure you want to continue?',
    serviceType: 'Service type',
    corpWX: 'WeChat Work',
    dingding: 'DingTalk',
    connectConfig: 'Connection configuration',
    serviceAddress: 'Server address',
    serviceManageAccount: 'Account name',
    password: 'Password',
    port: 'Port',
    fieldMapping: 'Field mapping',
    introduction:
      'Note: Due to the Enterprise WeChat policy, the self-built applications created after June 20, 2022 cannot obtain email addresses and mobile phone numbers. Therefore, accounts imported through Enterprise WeChat can only use single login and code scanning login. After the account has been imported successfully, you can add the email address and mobile phone number manually in the zBox system. If the self-built app you use was created before June 20, 2022, your email address and mobile phone number can be synced normally.',
    userID: 'User ID',
    userNameField: 'User name',
    emailField: 'User email',
    mobileField: 'User mobile',
    login: 'User login',
    teamID: 'Team ID',
    teamName: 'Team',
    allowMailImportToBeEmpty: 'The email addresses can be empty',
    mailImportToolTip:
      'If you uncheck this option, users without email address will not be imported',
    customField: 'Custom field',
    lenovoboxField: 'Network disk field',
    importField: 'Import fields',
    addField: 'Add fields',
    syncConfig: 'Synchronization configuration',
    defaultImportMode: 'Import mode',
    allImport: 'Import all',
    allNoImport: 'Import none',
    syncTime: 'Sync time',
    accordingDay: 'By day',
    accordingHour: 'By hour',
    hour: 'hour',
    min: 'minute',
    adfsCertificate: 'ADFS certificate (JKS format)',
    certificatePassword: 'Certificate password',
    adfsAddress: 'ADFS address',
    everyday: 'every day',
    every: 'Every',
    syncOperation: 'Synchronize now',
    log: 'Log',
    setServiceConfig: 'Set up service configuration',
    setFiltrationConditions: 'Set up filtering conditions',
    deleteSuccess: 'Deleted successfully',
    syncCompleteTime: 'Synchronization completion time',
    syncSuccess: 'Synchronized successfully',
    syncFail: 'Sync unsuccessful ',
    unSync: 'Unsynchronized',
    unSyncToolTip: 'Filter data that is not synchronized through the blacklist',
    export: 'Export',
    syncDetail: 'Sync details',
    detailSyncTime: 'Sync time',
    allSyncResult: 'All sync results',
    failReasons: 'Reasons for the failure',
    fail: 'Failed',
    user: 'User',
    created: 'Create',
    update: 'Update',
    unfrozen: 'Unfreeze',
    filter: 'Filtered',
    unSyncUser: 'Users not synchronized',
    unSyncTeam: 'Teams not synchronized',
    importServiceConfigCuccess: 'The service configuration import was added successfully!',
    filterInquiry: 'Do you want to set up the import filtering conditions now?',
    noSettings: 'Do not set up for now',
    goSettings: 'Go set up',
    addFilter: 'Add conditions',
    addFilterCondition: 'Add filtering conditions',
    modifyFilterCondition: 'Edit filtering conditions',
    batchImport: 'Import in bulk',
    userEmail: 'User email',
    userPhone: 'User mobile phone',
    userName: 'User name',
    teamUser: 'Team name',
    filteringContent: 'Filtered content',
    allConditionalType: 'All condition types',
    allFilterMode: 'All filtering methods',
    noImport: 'Do not import',
    conditionalType: 'Condition type',
    filterMode: 'Filtering method',
    importModeDesc: 'The import method can be changed in service configuration',
    addedNumber: 'Added',
    addedText: 'conditions',
    first: 'Step 1',
    downloadTemp: 'Download templates',
    downloadTempDesc: 'xls or xlsx file',
    second: 'Step 2',
    editedUpload: 'Upload after editing the content',
    uploadCertificate: 'Upload certificate',
    deleteItem: 'Delete selected items',
    selectedText: 'Are you sure you want to delete the selected items?',
    importLogTitle: 'Import the list of configuration logs',
    mostNumber: '10 fields at most',
    enterLenovoboxField: 'Enter the zBox field',
    enterImportField: 'Enter the import field',
    agentRelease: 'Proxy binding has been removed',
    noServiceConfig: 'No service configuration is added',
    noAgentService: 'No proxy service is added',
    syncConfigDesc: 'You may add filtering conditions to filter a part of the users',
    noDetailResulr: 'No corresponding search results',
    filterTitleTip:
      'All data will be imported by default. You may set it to not import any and add conditions to import a part of the data',
    importAcount: 'The total amount of imported items',
    copy: 'Copy',
    copySuccess: 'Copied',
    copyFail: 'Copy unsuccessful',
    serviceNamePlaceholder: 'Enter service configuration name using 50 characters at most',
    serviceAddressPlaceholder: 'e.g.: 120.22.100.11',
    manageAccountPlaceholder: 'Enter admin account of server to be connected',
    enterPasswordPlaceholder: 'Please enter your password',
    verificationRequired: 'Please enter the verification code',
    verificationTip: "Can't see clearly, please click",
    enterSearchValue: 'Enter content to be searched',
    selectFilterType: 'Select the type of filtering conditions',
    enterEmail: "Enter user's email address",
    enterUserPhone: "Enter user's mobile phone number",
    enterUserName: 'Enter username',
    enterTeamName: 'Enter team name',
    noSearchResult: 'Enter team name. Try another keyword.',
    beyondLimit: 'It exceeds the upper limit of 10,000',
    configSuccess: 'Configured successfully',
    deleteConfirm: 'Confirm deletion??',
    item: 'item',
    noFilterSearchResult: 'No corresponding search results. Please try another keyword.',
    character: 'Enter service configuration name in no more than 50 characters',
    noErrorSpecialCharacters: 'The following special characters are not allowed',
    isSyncing: 'Synchronizing',
    jksFile: 'JKS format',
    uploadJksFile: 'Upload files in the JKS format',
    inputCertificatePassword: 'Enter certificate password',
    address: 'Enter address',
    modifySuuccess: 'Modified successfully',
    agentPlaceholder: 'Enter proxy service name in no more than 50 characters',
    inputTeamOrUser: 'Enter username/team name for your search',
    addFilterSuccess: 'Filtering conditions added successfully',
    modifyFilterSuccess: 'Filtering conditions modified successfully',
    errorEmail: 'Invalid email format',
    errorMobile: 'Invalid mobile phone number format',
    bindingServerConfig: 'Third-party binding service configuration',
    matchingRule: 'Matching rule',
    mobile: 'Mobile number',
    email: 'Email',
    syncResult: 'Synchronize results',
    newBinding: 'New binding',
    failBinding: 'Binding failed',
    account: 'Account',
    bindingLogTitle: 'List of binding configuration logs',
    inputAccount: 'Enter account',
    signCongit: 'Qrcode configuration',
    scan: 'Qrcode configuration',
    qrcode: 'Qrcode configuration',
    sso: 'SSO configuration',
    scanName: 'Slug name',
    boxUrl: 'Access address of network disk',
    copyUrl: 'Copy address',
    identification: 'Match identification',
    appKeySecret: 'appKeySecret',
    ssoWarning:
      'Because you have used the proxy service, the system cannot obtain the proxy server address. Therefore, when you use the network disk to access the address, you need to manually fill in the IP or address of the proxy service in XXX location, for example: https://lenovows.com/user/manage',
    agentWarning: 'A maximum of 1 configuration can be added to the proxy service',
    importWarning: 'Organization import service adds up to 1 configuration',
    authWarning: 'Login authentication service can add up to 1 configuration',
    schema: 'schema',
    userStatus: 'user status',
    probation: 'probation',
    formal: 'formal',
    temporary: 'temporary',
    probationExtension: 'probation extension',
    dismissal: 'dismissal',
    resignation: 'resignation',
    retirement: 'retirement',
    invalid: 'Invalid. Only official users are synchronized',
    importSealTeam: 'Import seal team',
    yes: 'yes',
    no: 'no',
    relationship: 'relationship',
    appIdMobile: 'appIdMobile',
    appSecretMobile: 'appSecretMobile',
    applicationVoucher: 'application voucher',
    applicationVoucherTitle:
      'configure the application credentials of the connection pin to obtain the basic information of the nailing user',
    scanLogin: 'scan code to login',
    scanLoginTitle:
      'configure the authorization information of the nail scanning login application to realize the nail scanning code login on the network disk',
    mobileAuthorizedLogin: 'mobile authorized Login',
    mobileAuthorizedLoginTitle:
      'configure the "mobile app access share" authorization information to enable the mobile end to log in through pinning authorization',
    kingdee: 'Kingdee',
    createSuperiorTeam: 'Create parent team automatically',
    createSuperiorOrg: 'Create parent department automatically',
    autCreateSuperiorTeam:
      'The parent team will be created automatically when the added filter conditions are synchronized to the teams',
    autCreateSuperiorOrg:
      'The parent department will be created automatically when the added filter conditions are synchronized to the departments',
    all: 'Select all',
    serviceList: 'Plugin management',
    searchSuccess: 'Success',
    uploadError: 'Error',
    confirmClose: 'Confirm Close?',
    confirmOperation: 'Confirm operation？',
    loading: 'loading...',
    allSuccess: 'Success',
    startSuccess: 'Success',
    closeSuccess: 'Success',
    uploadSuccess: 'Success',
    delConfirm: 'Are you sure you want to delete',
    marne_captcha_config: 'marne Captcha Config',
    marne_approve_config: 'Approval integration',
    api: 'Openapi Document',
    feishu: 'Feishu',
    okta: 'Okta',
    browse: 'browse',
    browse_error: 'Please enter the correct Base DN',
    browse_tip:
      'Modifying the base DN will affect the configured filter conditions and may cause the filter conditions to become invalid. Please modify it carefully',
    condition_filter: 'Filter condition',
    filter_type: 'Filter by type',
    filter_condition: 'Filter by condition',
    filter_custom: 'Custom filter conditions',
    user: 'User',
    ou: 'Organizational unit',
    group: 'Group',
    filter_type_tip:
      'When setting filter conditions by type, the data under Base DN will be synchronized to the zBox system according to the type selected above.',
    add_condition: 'Add condition',
    condition_has_added: 'The condition has been added',
    filter_condition_tip:
      'When setting filter method by condition，the selected specified object will be synchronized to the zBox system',
    repeat_condition_tip:
      'The superior nodes of the above conditions have been added as conditions, so these conditions will be deleted automatically, and the final import range will not be affected after deletion',
    set_condition: 'Set filter conditions',
    filter_custom_placeholder: 'Please enter your filter condition such as cn=D_group1',
    all_types: 'All types',
    filter_settings: 'Filter settings',
    filter_method: 'Filter method',
    search: 'Search',
    checked_items: '{x} items have been checked',
    total_items: 'Total {x} items',
    selected_items: '{x} items have been selected',
    select_all: 'Select all',
    select: 'Select',
    connect_error: 'Unable to connect to the server',
    connect_error_tip:
      'The connection information may be configured incorrectly or the server may be abnormal',
    add: 'Add',
    select_baseDN: 'Select base DN',
  },
  app: {
    reset: 'Reset',
    confirmReset: 'Reset',
    cancel: 'Cancel',
    resetTile: 'Are you sure to reset App Secret?',
    resetDesc:
      'The existing App Secret will be invalid after reset, which may affect some functions',
    resetSuccess: 'Reset Success',
    resetError: 'Reset Error',
    usePackageRequird: 'You must enter the number of APP packages',
    usePackageRate: 'Cannot be less than the set frequency {0} / 100',
    packageNum: 'Number of application packages to be used',
    UsePackageNum: 'Number of available application packages',
    updateTime: 'Update time',
    surplus: '{0} remaining',
    packageCreateTip: 'Create failed. The number of application packages is insufficient',
    packageSetTip: 'Set up failed. The number of application packages is insufficient',
    packageRateLimit:
      'Setting a larger range of interface frequency times requires increasing the number of application packages',
    usePackageTip:
      'One application package can create one application, and the configurable interface frequency is 100 times per minute. It is also possible to apply multiple application packages to increase the number of interface frequencies on one application.',
    currentPackageNum: 'Available',
    thirdApp: 'Third party applications',
    appManager: 'Application management',
    createApp: 'Create application',
    editApp: 'Edit Information',
    editAppDialog: 'Edit integration template',
    scene: 'Applicable scenarios',
    Prerequisites: 'Configured',
    unconfined: 'Not configured yet',
    datacenter: 'Data center',
    err_region: 'Select a data center',
    region_tip: 'Data center is configured',
    setMessage: 'Set message template',
    nodesc: 'No description has been added yet',
    appName: 'Application name',
    appDesc: 'Application description',
    appIcon: 'Application icon',
    ipManage: 'IP management',
    addApiIp: 'Add allowed IP',
    appNameTip: 'Please enter the application name, no more than 50 characters',
    addIpDesc:
      'Fill in the allowed IP addresses. Please separate multiple IPs with a comma. IP segment It is supported to fill in the IP segment. The IP start address and end address are separated by "-"',
    rateLimit: 'Interface request frequency limit',
    setRateLimit: 'Set interface request frequency limit',
    rateLimitDesc:
      'In order to prevent server load exception caused by frequent application calls, there is a frequency limit for each server interface call by default. When this limit is exceeded, the corresponding error code will be returned when calling the corresponding interface.',
    rateLimitNumber: 'Need to prompt upper limit number',
    rateLimitUnit: 'times/min',
    appVoucher: 'Application credentials',
    apiBaseInfo: 'Basic information',
    appAvatar: 'Application icon',
    editInfo: 'Edit',
    backUp: 'Back to application management',
    deleteApp: 'Delete',
    voucher: 'Credentials and basic information',
    authManage: 'Authority management',
    createError: 'createError',
    modifySuccess: 'Edited successfully',
    modifyError: 'Edited failed',
    delSuccess: 'Deleted successfully',
    delError: 'DeleteError',
    modifyAuthSuccess: 'Modify Authority Success',
    modifyAuthError: 'Modify Authority Error',
    deleteApiConfirm: 'Delete confirmation',
    appNumLimit:
      'Cannot create application. The number of applications has reached the upper limit.',
    ipFormatError: 'IP range format error',
    deleteConfirmTitle: 'Please confirm whether to delete this application?',
    deleteApiDesc:
      'Please check the application information. It cannot be restored after deletion, and the credential will be invalid',
    imgFormatLimit: 'Only supports JPG or PNG',
    imgBulkLimit: 'The icon size must be less than 120KB',
    imgSizeLimit: 'The icon must be 240*240px or more',
    imgTip:
      'Please upload an icon without rounded corners, please confirm the format is JPG/PNG, the pixel is 240*240px or more, the ratio is 1:1, and the size is within 120kb',
    appNameRequired: 'Application name cannot be empty',
    appNameIsExit: 'Application name already exists',
    ipRequired: 'Please add access IP',
    appDescTip: 'Please enter the description, no more than 200 characters',
    appVoucherDesc:
      'The application credential contains two fields, Appkey and AppSecret. This field is the credential information that needs to be passed when calling the API. Users should keep it properly.',
    baseInfoDesc:
      'Basic information includes application name, description and icon. Users can modify the information as needed.',
    ipDesc:
      'In order to prevent the connection of unknown IP, please add the IP addresses allowed to access the application. Unknown IP cannot be connected to the application.',
    authDesc:
      'You can management the interface capabilities that the application can call. The selected authority is the callable interface.',
    rateDesc:
      'In order to prevent frequent calls which may cause loader exceptions, each server interface request has a frequency limit. When this limit is exceeded, the corresponding error code will be returned.',
    rateCount:
      'Interface request frequency limit is the maximum number of requests per minute. The upper limit that can be set is {0} times/min. Setting a larger range of interface frequency times requires increasing the number of application packages',
    rateLimitTip: 'The upper limit that can be set is {0}',
    intSpace: 'Please enter a positive integer',
    rateRequired: 'Application frequency limit cannot be empty',
    ratePlaceholder: 'Please enter the content',
    rateMinLimit: 'Not less than 100 times / min',
    rateFormat: 'A multiple of 100 must be set',
    integrated: 'Integration management',
    createIntegrated: 'Create a integration template',
    deleteIntegrated: 'Delete template',
    integratedInfo: 'integrated Info',
    message: 'Message',
    backIntegrated: 'return Integrated',
    systemName: 'System name',
    integrationType: 'Integration type',
    systemType: 'System type',
    'main datacenter': 'Primary data center',
    status: 'State',
    messageError: 'The message template is empty and cannot be committed',
    operation: 'Operation',
    set: 'Settings',
    systemIcon: 'System icon',
    systemNameTip: 'The system name is occupied.',
    createSuccess: 'Created success',
    baseInfoTip: 'Before create a new template, please delete the current one.',
    ipManagement: 'IP management',
    ipWhite: 'IP whitelist',
    ipExclude: 'Double-factor login does not work under this IP.',
    addIp: 'Add an access IP',
    ipTip:
      'Fill in the allowed IP addresses.Please separate multiple IPs with a comma. IP segment lt is supported to fill in the IP segment. The IP start address and end address are separated by"-".',
    ipPlc: 'Please enter a IP address.',
    save: 'Save',
    Restore: 'Restore',
    ipError: 'Incorrect IP entered',
    saveSuccess: 'Save succeeded',
    messageTemplate: 'Message template',
    templateDesc: 'The template content is an example of a message to send a verification code.',
    messageDesc:
      'Content in {} cannot be changed.Message content cannot be sent normally after modification.',
    setTemplate: 'Templeate setting',
    messageNotNull: 'Message cannot be empty, please fill the reqired file.',
    messageTip: 'Invalid code, please match the format requested: {XXXXXX}.',
    deleteConfirm2: 'Comfirm delete',
    deleteTip: 'Are you sure you want to delete this integration template? ',
    deleteDesc: 'The deleted file cannot be recovered, and all settings will be invalid.',
    deleteSuccess: 'Delete successfully',
    comfirm: 'Comfirm',
    templateInfo: 'Template Info',
    baseInfo2: 'Base Info',
    messagePlc:
      'The varification code is {XXXXXXX}, please complete verification as soon as possible. If you did not make this request, please ignore this message.',
    inputTip: 'Enter up to 100 characters',
    createErrorTip:
      'The integration type has reached the upper limit and cannot continue to be created',
    deleteApproveDesc:
      'After deleting the integrated approval application, the approval function will not work normally',
    imgFormatLimit2: 'Please upload a JPG/PNG file.',
    imgBulkLimit2: 'Image not larger than 120KB.',
    imgSizeLimit2: 'Image must larger than 240*240 pixels.',
    actionConfirm: 'Operation confirmation',
    stopTip: 'Are you sure you want to stop this plug-in?',
    stopDesc: 'After stopping, the service corresponding to the plug-in will become invalid',
    listDeleteTip: 'Are you sure you want to delete this plug-in?',
    listDeleteDesc: 'After deleting, the service corresponding to the plug-in will become invalid',
    integratedVoucherDesc:
      'The application credential contains two fields, Appkey and AppSecret. This field is the credential information that needs to be passed when calling the integrated application. Users should keep it properly.',
    integratedTmpInfo:
      'The integration information includes the integration type and system type. If changes are required, it can be deleted and recreated.',
    integratedBaseInfo:
      'The basic information includes information such as application name and application configuration, which can be modified by users as needed.',
  },
  document: {
    header: {
      title: 'OpenDockingPlatform',
      api: 'ServiceAPI',
      login: 'Login',
      tools: 'Development Tool',
    },
    noResponseExample: 'No ResponseExample',
    UpdateTimeValue: 'May 10, 2021',
    updateTime: 'updateTime',
    Summary: 'Summary',
    ProductGuide: 'ProductGuide',
    IntroductionToTerms: 'IntroductionToTerms',
    usageMethod: 'UsageMethod',
    getToken: 'GetToken',
    useToken: 'UseToken',
    GlobalReturnCode: 'GlobalReturnCode',
    InterfaceDesc: 'InterfaceDesc',
    baseInfo: 'BaseInfo',
    requestType: 'RequestType',
    requestAddress: 'RequestAddress',
    requestParam: 'RequestParam',
    param: 'Param',
    type: 'Type',
    action: 'Action',
    name: 'Name',
    required: 'Required',
    place: 'Place',
    desc: 'Description',
    default: 'Default',
    yes: 'Yes',
    no: 'No',
    file: 'File',
    requestExamples: 'RequestExamples',
    responseParam: 'ResponseParam',
    responseExample: 'ResponseExample',
    team: 'Team',
    user: 'User',
    api_errorcode: 'Error code, success: 0',
    api_file_list: 'Get the file list',
    api_file_list_desc: 'Get the list of files in the specified path.',
    ContentType_field_desc: 'Should be application/x-www-form-urlencoded',
    modified_field_desc: 'The last modified time',
    path_field_desc: 'File path',
    pathType_field_desc: 'Path type: ent—enterprise space, self—self space',
    rev_field_desc: 'File version',
    size_field_desc: 'File size',
    creator_field_desc: 'File creator',
    creatorUid_field_desc: 'The id of file creator',
    updator_field_desc: 'File updator',
    updatorUid_field_desc: 'The id of file updator',
    isteam_field_desc: 'Is it a team folder',
    filedata_field_desc: 'File body',
    Format: 'bytes=0-4194304,bytes=4194304',
    api_get_token: 'Get token',
    api_use_token: 'Using token',
    api_token_field_desc:
      'The format is Basic base64([appKey]:[appSecret]) For example, for appKey=aaa and appSecret=bbb, you need to type out "aaa:bbb" first, and then base64 encode, the final request header is Authorization: Basic YWFhOmJiYg==',
    api_token_path_field_desc: 'Fixed value here: client_with_su',
    api_token_path_field_desc_scope:
      'The range of operations that the application can do to the user. The fixed value all is required here',
    api_token_slug:
      'User login name. This indicates which user can call the API on behalf of the token generated.',
    api_get_token_error: 'Fail to request the token:',
    api_token_error: 'Token expired or do not exist:',
    api_token_scope: 'Token expired or do not exist:',
    api_token_token_type: 'Fixed as bearer currently.',
    api_token_access_token: 'Fixed as bearer currently.',
    api_token_expires_in: 'The valid time of the token.',
    api_token_content_code: 'The valid time of the token.',
    api_token_cankao: 'reference',
    api_token_yuanyin: 'reason',
    api_token_chenggong: 'Request succeeded',
    api_token_shibai: 'Parameter error',
    api_token_yichang: 'Parameter error',
    api_token_jinzhi: 'Operation is prohibited',
    api_token_bucunzai: 'The requested entity does not exist',
    api_token_buyunxu: 'The method specified in the request is not allowed',
    api_token_chongtu: 'The requested resource does not meet the prerequisites',
    api_token_weimanzu: 'Resource requested in conflict',
    api_token_cuowu: 'Service internal error',
    api_token_fanhui: 'Return fields',
    api_token_zhuyishixiang: 'Attention',
    api_token_zhuyishixiang_decs1:
      'Developers need to cache access_token for subsequent interface calls (note: this interface will be intercepted if called frequently). When the access_token becomes invalid or expires, it needs to be obtained again.',
    api_token_zhuyishixiang_decs2:
      'The validity time of the access_token is conveyed by the returned expires_in. Repeated acquisition of the token for the same user within the validity period of the same application will return the same result, and the acquisition after the expiration will return a new access_token.',
    api_token_zhuyishixiang_decs3:
      'Due to operating strategies, there is no guarantee that the token will continue to be valid during the validity period. Developers should implement the logic of reacquiring access_token when it becomes invalid.',
    api_token_zhuyishixiang_decs4: 'The access_token reserves at least 512 bytes of storage space.',
    api_use_token_decs1:
      'After obtaining the token, you can use the API provided by the open platform. When calling the API, you only need to add the Authorization request header as shown below.',
    api_use_token_decs2: 'Authorization: bearer [token]',
    api_use_token_decs3: 'Please replace [token] with the token content obtained before.',
    api_token_subtitle:
      'Obtaining the token is the first step to call the open platform API. Almost all business APIs need to rely on the token to determine the identity of the caller (application, app) and user (user).',
    api_chanpinzhinan_decs1:
      'Filez open platform is a service platform that provides enterprises with secondary development based on the basic business and functions of zBox, and provides enterprises with intelligent and safe multi-person file editing, collaboration and management solutions. The platform targets at enterprise or third-party developers and is connected with the internal system of the enterprise through an open interface to meet the enterprise customized file management needs.',
    api_chanpinzhinan_decs2:
      'Filez provides APIs in four parts: file operation, link management, team management, and user management. Enterprises can use these APIs to empower their file management.',
    api_mingcijieshao1: '1.	Application（app）',
    api_mingcijieshao_decs1:
      'An application (app) represents the caller of open platform APIs. Currently, the open platform API does not provide an anonymous access mechanism, so you need to hold application identity information (see the token explanation for details) to use the API provided by the open platform.',
    api_mingcijieshao_decs2: 'The application identity information contains two fields:',
    api_mingcijieshao_decs3:
      '“appKey” is used to uniquely identify the information of an application (equal to a user name)',
    api_mingcijieshao_decs4:
      '“appSecret” is used to prevent fraudulent use of application information (equal to a password)',
    api_mingcijieshao_decs5:
      'The open platform provides these two fields, and users should keep them properly. To ensure security, appSecret should only be passed when called in the background.。',
    api_mingcijieshao2: '2.	User（user）',
    api_mingcijieshao_decs7:
      'Unless otherwise specified in this document, it refers to filez Box users.',
    api_mingcijieshao3: '3.	Token（token）',
    api_mingcijieshao_decs8:
      'The token is the credential information that needs to be passed to call all APIs. If you want to call the API, you need to bring application information and user information to the specified endpoint to apply for a token (see the following section for details). This means that one token corresponds to one application information and one user information. If you want to call the API with several different users  identities, you need to apply for a token once for each user.',
    api_mingcijieshao4: '4.	Parameters',
    api_mingcijieshao_decs9:
      'Calling the API requires passing parameters. In subsequent chapters, we use square brackets to represent the parameters that need to be passed. For example, token=[token], which means you need to replace [token] with the parameters that need to provide. In addition, some parameters need to be processed by specific functions. We use italics for processing functions, such as base64([token]), which means that after the token parameter is passed, base64 encoding is performed again.',
    api_box_sessionid: 'Sessionid',
    orgteam: 'Department',
    createOrgteam: 'Create department',
    modifyOrgteam: 'Update department information',
    deleteOrateam: 'deleteOrateam',
    dismissOrateam: 'Dissolve department',
    getListOfOrateam: 'Get department list',
    getInfoOfOrateam: 'Get department information',
    BatchPreview: 'Get URLs of preview page in batches',
    api_dept_update_desc_1: 'Update department information according to department ID',
    OrguserCreate: 'Create department user relationship',
    authorize: 'Permission(Sharing)',
    modifyAuth: 'Add or modify permission(Sharing)',
    cancelAuth: 'Delete permission(Sharing)',
    getAuthList: 'Get the permission(Sharing) list',
    onlineEditing: 'Online editing',
    bookmarkId_field_desc: 'Favorite ID',
    supportPreview_field_desc: 'Whether to support preview',
    isBookmark_field_desc: 'Whether it is favorite file',
    fileSearch: 'File Search',
    authorization: 'The format is bearer [token]',
    nsid: '	Namespace id',
    errCode: 'Error code, success: 0',
    errMsg: 'Error description, success: ok',
    path: 'Path',
    isSubteamInheritable: 'Whether it can be inherited',
    neid: 'File id',
    pathType: 'Path Type',
    updator: 'Updater',
    updatorId: 'Updater ID',
    size: 'File size',
    creator: 'Creator',
    creatorId: 'Creator ID',
    creatorUid: 'Creator ID',
    fileVersion: 'File version',
    dateTime: 'October 27, 2021',
  },
  api: {
    install: 'Installation',
    import: 'import',
    get: 'Get accessToken',
    full: 'Full in accessToken',
    downloadSDK: 'DownloadSDK',
    environmental_dependence: 'Environmental dependence',
    dependent_package: 'Dependent package:',
    api_dowload_sdk_request_example: 'SDK request example',
    api_dowload_sdk_download: 'SDK Download',
    api_dowload_sdk_manual_download: 'SDK Manual download',
    api_dowload_sdk_postman_invocation: 'Postman invocation',
    api_dowload_sdk_document_postman: 'Download the document ‘postman’',
    api_dowload_sdk_desc:
      'Filez open platform provides a unified SDK, which facilitates the calling of Filez API.',
    api_dowload_sdk_request_example_tip:
      'The following is request example to call the API through the SDK:',
    api_dowload_sdk_api_notes_1:
      'Initialize boxSDK，create oauthClient obtain accessToken，create request corresponding client。',
    api_dowload_sdk_api_notes_2: 'Call create user request ',
    api_dowload_sdk_api_following: 'Notes',
    api_dowload_sdk_notes_1:
      '1.‘apiUrl’ is the address to connect to the Filez. ‘slug’ is the user who calls the api. The ‘token’ generated by this user can only be used by himself. ‘appKey’ and ‘appSecret’ are application credentials, as shown below：',
    api_dowload_sdk_notes_2:
      '2.‘TokenModel’ contains fields: details of token(accessToken), type of token(tokenType), expiration date (expiresIn), and scope (scope).',
    api_dowload_sdk_notes_3:
      '3.Create a client according to the type of interface. Example: To call the interface of creating user, you have to create a ‘userClient’. ',
    api_dowload_sdk_notes_4:
      '4.Call the method used to request using the interface in the class ‘client’. For example, to create a user, you have to call the method ‘userClient.create()’ . Each method needs to be passed in the ‘TokenModel.getAccessToken()’. For specific methods and parameters, please check the interface annotation of the class ‘client’ in the SDK.',
    api_dowload_sdk_notes_5:
      '5.In the SDK, user-related operations need to call the sample class ‘UserClientSample’, team-related operations need to call the sample class ‘TeamClientSample’, file-related operations need to call the sample class ‘FileClientSample’, external-related operations need to call the sample class ‘DeliveryClientSample’, organization-related operations need to call the sample class ‘OrgClientSample’, and organize user-related operations need to calls the sample class ‘OrgUserClientSample’.',
    api_dowload_sdk_install: 'Manually add ‘java-sdk-2.2.jar’ to the project',
    api_dowload_sdk_environmental_dependence:
      '‘Java SDK’ needs to rely on ‘Java SE/EE 1.7’ and above.',
    api_dowload_sdk_download_book: 'Java SDK manual',
    api_dowload_sdk_postman_desc:
      'This document mainly introduces the use of the tool ‘API Postman’ of Filez open platform.',
    api_dowload_sdk_postman_desc_1:
      '1.	Import the document ‘Marne Api.postman_collection.json’ into ‘Postman’.',
    api_dowload_sdk_postman_get_accessToken_1:
      '1. Call the interface ‘/v2/oauth/token’ to get token, and select the authentication type ‘Basic Auth’, apply ‘appKey’ to the ‘Username’, apply ‘appSecret’ to the ‘Password’. ',
    api_dowload_sdk_postman_get_accessToken_2:
      '2. The request parameter ‘grant_type’ is the fixed value which is ‘client_with_su’, the ‘scope’ is the fixed value which is ‘all’, and the ‘slug’ is the user login name. ',
    api_dowload_sdk_invocation_example: 'Invocation example：',
    webtoolSDK: 'Batch download tool',
    webtoolDesc:
      "The batch download tool is used to batch download after the three-party system is connected to Filez. After the three-party system is connected to the download function of Filez, when terminal users want to perform batch download in the connected system, they can  invoke the batch download tool to do it. Therefore, it is necessary to ensure that the batch download tool must be installed on terminal users' computers, and the tool only supports Windows terminals.",
    toolSchematic: 'Tool schematic',
    webtoolDesc2:
      'You can view the download details and manage the download tasks. You can start, pause, and cancel tasks in the process of downloading.',
    webtoolDesc3: 'You can customize the default download path',
    downloadLink: 'Download link',
    documentLink: 'Document link',
  },
}



// WEBPACK FOOTER //
// ./static/js/language/en.js